import {useMemo} from 'preact/hooks';

import {getConfiguration} from 'utilities/configuration';
import {BrandHandle} from 'utilities/delivery-promise';
import {Theme} from 'utilities/color';

import {PipelineProps, Scenario} from '../types';
import {getDefaultScenario} from '../helpers';

import {destinationAddress} from './shop-promise-pipeline.hook';

function optimusLines(
  defaultOptimusPdpUrl: string,
  currentScenario: Scenario,
  {deliveryEstimates, theme}: PipelineProps,
) {
  const {brandedPromise, deliveryPromisePresentmentTitle} =
    deliveryEstimates?.selectedShippingOption || {};
  const logo =
    theme === Theme.Dark ? brandedPromise?.darkLogo : brandedPromise?.lightLogo;

  const showLogo = Boolean(brandedPromise);
  const src = logo?.src || '';
  const altText = logo?.altText || '';
  const brandHandle = brandedPromise?.handle;
  const sdkURL = brandedPromise?.sdkURL ?? defaultOptimusPdpUrl;

  return {
    ...currentScenario,
    showLogo,
    logoSrc: src,
    logoAltText: altText,
    brandHandle,
    sdkURL,
    locationPrefix: '',
    title: `${deliveryPromisePresentmentTitle}`,
  };
}

function noPromiseForUnqualifiedEstimate(
  currentScenario: Scenario,
  {deliveryEstimates}: PipelineProps,
): Scenario {
  const selectedShippingOption = deliveryEstimates?.selectedShippingOption;

  const currency = window?.ShopifyAnalytics?.meta?.currency;
  const brandHandle = selectedShippingOption?.brandedPromise
    ?.handle as BrandHandle;

  let noPromiseReason: string | undefined;

  if (!selectedShippingOption) {
    noPromiseReason = 'no_shipping_option_selected';
  } else if (
    brandHandle === BrandHandle.Prime &&
    currency?.toUpperCase() !== 'USD'
  ) {
    noPromiseReason = 'prime_brand_requires_usd_currency';
  }

  if (noPromiseReason) {
    return {
      ...getDefaultScenario(),
      hidePromise: true,
      noPromiseReason,
    };
  }

  return currentScenario;
}

export function useOptimusPipeline() {
  const {optimusPdpUrl} = getConfiguration();

  return useMemo(
    () => [
      destinationAddress,
      optimusLines.bind(null, optimusPdpUrl),
      noPromiseForUnqualifiedEstimate,
    ],
    [optimusPdpUrl],
  );
}
